// extracted by mini-css-extract-plugin
module.exports = {"container":"not_found_message_container__1Mz7D","notFound":"not_found_message_notFound__bruAo"};